import { Formik } from "formik";
import * as React from "react";
import { toast } from "react-toastify";
import * as yup from "yup";

import Grid from "src/library/components/Hedron";
import { Button } from "src/library/components/Button";
import {
  FormRow,
  Input,
  Label
} from "src/library/components/Forms";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import DeliveryDaysPicker from "src/core/shared/components/DeliveryDaysPicker";
import { deliveryRoutesApi } from "src/core/shared/api/deliveryRoutes.api";
import { PageProps } from "src/pages/Router/routes";
import { IDeliveryRoute } from "src/core/drops/api/drops.api";

interface URLParams {
  deliveryRouteId: string;
}

/**
 * Edit a delivery route page
 *
 */
const EditDeliveryRoutePage: React.ReactFCWithChildren<PageProps<unknown, URLParams>> = props => {
  const { match, history } = props;
  const deliveryRouteId = match ? parseInt(match.params.deliveryRouteId, 0) : 0;
  const [ updateDeliveryRouteResponse, updateDeliveryRoute ] = deliveryRoutesApi<IDeliveryRoute>("UPDATE_DELIVERY_ROUTE");
  const [ getDeliveryRouteResponse, getDeliveryRoute ] = deliveryRoutesApi<IDeliveryRoute>("GET_DELIVERY_ROUTE");
  const [ deliveryRoute, setDeliveryRoute ] = React.useState<IDeliveryRoute | null>(null);
  const [ inheritedDeliveryRoute, setInheritedDeliveryRoute ] = React.useState<IDeliveryRoute | null>(null);

  React.useEffect(() => {
    getDeliveryRoute(deliveryRouteId);
  }, []);

  React.useEffect(() => {
    if (getDeliveryRouteResponse.data) {
      if (getDeliveryRouteResponse.data.id !== 1) {
        setDeliveryRoute(getDeliveryRouteResponse.data);
        getDeliveryRoute(1);
      } else {
        setInheritedDeliveryRoute(getDeliveryRouteResponse.data);
      }
    }
  }, [ getDeliveryRouteResponse ]);

  React.useEffect(() => {
    if (updateDeliveryRouteResponse.data) {
      history.push("/admin/delivery-routes");
    }

    if (updateDeliveryRouteResponse.error) {
      toast.error("Could not update delivery route.");
    }
  }, [ updateDeliveryRouteResponse ]);

  const handleSubmitSettings = (form: IDeliveryRoute) => {
    updateDeliveryRoute(form);
  };

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <Grid.Bounds direction="vertical">
          {deliveryRoute && (
            <Formik
              validationSchema={yup.object().shape({ name: yup.string().required() })}
              initialValues={deliveryRoute}
              onSubmit={handleSubmitSettings}
              render={({
                handleSubmit, values, setFieldValue
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <FormRow>
                      <Input
                        value={values.name || ""}
                        name="name"
                        label="Name"
                        handleChange={e => setFieldValue("name", e.currentTarget.value)}
                      />
                    </FormRow>

                    <FormRow>
                      <Label
                        label="Delivery Days:"
                        for="deliveryDays"
                      />

                      {inheritedDeliveryRoute && (
                        <DeliveryDaysPicker
                          deliveryRoutes={[]}
                          value={values}
                          inherited={inheritedDeliveryRoute}
                          isGlobal
                          type="global"
                          handleChange={deliveryRoute => {
                            if (deliveryRoute) {
                              setFieldValue("deliveryDays", deliveryRoute.deliveryDays);
                            }
                          }}
                        />
                      )}
                    </FormRow>

                    <FormRow>
                      <Button type="submit">
                        Save
                      </Button>
                    </FormRow>
                  </form>
                );
              }}
            />
          )}
        </Grid.Bounds>
      </MainContentWrapper>
    </Layout>
  );
};

export default EditDeliveryRoutePage;
